'use es6';

import { chunk } from 'underscore';
import { getPropertyFrequencyBuckets, getPropertyAggregations } from 'FormsUI/api/CrmSearch';
import { getSubmissionsPropertyFrequencies, getSubmissionsPropertyAggregations } from '../selectors/CrmSearch';
function createAction(name) {
  return `@@crmSearch/${name}`;
}
const MAX_NUMBER_OF_AGGREGATIONS = 10;
export const REQUEST_PROPERTY_AGGREGATIONS = createAction('REQUEST_PROPERTY_AGGREGATIONS');
export const RECEIVE_PROPERTY_AGGREGATIONS = createAction('RECEIVE_PROPERTY_AGGREGATIONS');
export const FAIL_FETCHING_PROPERTY_AGGREGATIONS = createAction('FAIL_FETCHING_PROPERTY_AGGREGATIONS');
export const REQUEST_FORM_SUBMISSIONS_PROPERTY_VALUE = createAction('REQUEST_FORM_SUBMISSIONS_PROPERTY_VALUE');
export const FAIL_GETTING_FORM_SUBMISSIONS_PROPERTY_VALUE = createAction('FAIL_GETTING_FORM_SUBMISSIONS_PROPERTY_VALUE');
export const RECEIVE_FORM_SUBMISSIONS_PROPERTY_VALUE = createAction('RECEIVE_FORM_SUBMISSIONS_PROPERTY_VALUE');
export const CLEANUP_ANALYSE_DATA = createAction('CLEANUP_ANALYSE_DATA');
export function cleanupAnalyseData() {
  return {
    type: CLEANUP_ANALYSE_DATA
  };
}
const requestPropertyAggregations = (fields, dateRange) => ({
  type: REQUEST_PROPERTY_AGGREGATIONS,
  fields,
  dateRange
});
const receivePropertyAggregations = (aggregations, dateRange) => ({
  type: RECEIVE_PROPERTY_AGGREGATIONS,
  aggregations,
  dateRange
});
const failedFetchingPropertyAggregations = (fields, dateRange, error) => ({
  type: FAIL_FETCHING_PROPERTY_AGGREGATIONS,
  fields,
  dateRange,
  error
});
export const fetchFormSubmissionPropertyAggregations = (formGuid, fields, dateRange) => (dispatch, getState) => {
  const state = getState();
  chunk(fields.filter(field => {
    return getSubmissionsPropertyAggregations(state, field.name, dateRange).requestState.shouldBeRequested();
  }), MAX_NUMBER_OF_AGGREGATIONS).forEach(properties => {
    const propertyNames = properties.map(p => p.name);
    dispatch(requestPropertyAggregations(propertyNames, dateRange));
    return Promise.all(properties.map(({
      name,
      objectTypeId
    }) => getPropertyAggregations(formGuid, name, dateRange, objectTypeId))).then(responses => {
      dispatch(receivePropertyAggregations(properties.map((field, index) => {
        return {
          field: field.name,
          breakdown: responses[index].results.reduce((obj, item) => Object.assign({}, obj, {
            [item.label]: item.count
          }), {})
        };
      }), dateRange));
    }).catch(error => dispatch(failedFetchingPropertyAggregations(propertyNames, dateRange, error)));
  });
};
export const REQUEST_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES = createAction('REQUEST_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES');
export const SUCCEED_GETTING_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES = createAction('SUCCEED_GETTING_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES');
export const FAIL_GETTING_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES = createAction('FAIL_GETTING_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES');
const requestPropertyFrequencies = (offset, includeRequiredFields, dateRange) => ({
  type: REQUEST_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES,
  offset,
  includeRequiredFields,
  dateRange
});
const receivePropertyFrequencies = (response, offset, includeRequiredFields, dateRange) => ({
  type: SUCCEED_GETTING_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES,
  response,
  offset,
  includeRequiredFields,
  dateRange
});
const failedFetchingPropertyFrequencies = (offset, includeRequiredFields, dateRange) => ({
  type: FAIL_GETTING_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES,
  offset,
  includeRequiredFields,
  dateRange
});
export const fetchFormSubmissionPropertyFrequencies = (formGuid, offset, includeRequiredFields, dateRange) => (dispatch, getState) => {
  if (!getSubmissionsPropertyFrequencies(getState(), offset, includeRequiredFields, dateRange).requestState.shouldBeRequested()) {
    return Promise.resolve();
  }
  dispatch(requestPropertyFrequencies(offset, includeRequiredFields, dateRange));
  return getPropertyFrequencyBuckets(formGuid, offset, includeRequiredFields, dateRange).then(response => {
    dispatch(receivePropertyFrequencies(response, offset, includeRequiredFields, dateRange));
  }).catch(() => {
    dispatch(failedFetchingPropertyFrequencies(offset, includeRequiredFields, dateRange));
  });
};